import { lazy, Suspense } from 'react'
import { TrackActionProvider } from '@opallabs/analytics'
import { SimpleWorkspace } from '@opallabs/concepts'
import { DefaultQueryClientProvider } from '@opallabs/higgs'
import { WorkspaceContext } from '@opallabs/hooks'
import { CurrentUserProvider } from './Contexts/CurrentUserProvider'
import type { MomentWorkflowProps } from './index'

const MomentWorkflow = lazy(() => import('./index'))

export const Workflow: React.VFC<
  MomentWorkflowProps & { currentWorkspace?: SimpleWorkspace }
> = (props) => (
  <Suspense fallback={null}>
    <DefaultQueryClientProvider>
      <TrackActionProvider>
        <CurrentUserProvider>
          <WorkspaceContext.Provider value={props.currentWorkspace}>
            <MomentWorkflow {...props} />
          </WorkspaceContext.Provider>
        </CurrentUserProvider>
      </TrackActionProvider>
    </DefaultQueryClientProvider>
  </Suspense>
)
